import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setLessonPassed } from '../../../actions/classbook'
import HomeworkModal from '../../../components/HomeworkModal/HomeworkModal'

const typeIcon = (type) => {
    if (!type) return '?'
    if (type === 'Урок') return '☆'
    return type
}

const ClassbookChart = ({ data, formData }) => {

    const dispatch = useDispatch()
    const { lessons } = useSelector(state => state.classbook)
    const [localData, setLocalData] = useState(null)
    const [hwModal, setHwModal] = useState(null)

    useEffect(() => {
        setLocalData(data)
    }, [data])

    const handlePassedChange = (id) => {
        const item = localData?.find(i => i.sh_mod_fact_id === id)
        if (!item) return
        const newPassed = !item.passed
        setLocalData(localData.map(i => i.sh_mod_fact_id === id ? { ...i, passed: newPassed } : i))
        dispatch(setLessonPassed(id, newPassed))
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <span className={styles.headerTitle}>Уроки / темы / ДЗ</span>
                <span className={styles.headerHint}>клик по теме — карточка</span>
            </div>

            <div className={styles.tableWrapper}>
                <table>
                    <colgroup>
                        <col className={styles.colNum} />
                        <col className={styles.colCheck} />
                        <col className={styles.colType} />
                        <col className={styles.colDate} />
                        <col className={styles.colTopic} />
                        <col className={styles.colHw} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Пров.</th>
                            <th>Тип</th>
                            <th>Дата</th>
                            <th>Пройдено</th>
                            <th>ДЗ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {localData?.map(item => (
                            <tr
                                key={item.sh_mod_fact_id}
                                className={item.passed ? styles.rowPassed : ''}
                            >
                                <td className={styles.tdNum}>{item.les_num || ''}</td>
                                <td className={styles.tdCheck}>
                                    <input
                                        type="checkbox"
                                        checked={!!item.passed}
                                        onChange={() => handlePassedChange(item.sh_mod_fact_id)}
                                        className={styles.checkbox}
                                    />
                                </td>
                                <td className={styles.tdType}>{typeIcon(item.event_type_j)}</td>
                                <td
                                    className={styles.tdDate}
                                    style={{ fontWeight: item.hw_text_j ? '700' : '400', cursor: 'pointer', color: '#1671ef' }}
                                    onClick={() => setHwModal(item)}
                                >
                                    {moment(item.les_date).format('DD.MM.YY')}
                                </td>
                                <td className={styles.tdTopic}>
                                    {item.topic_text_j
                                        ? <span className={styles.topicLink}>{item.topic_text_j}</span>
                                        : ''}
                                </td>
                                <td className={styles.tdHw}>{item.hw_text_j || ''}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <HomeworkModal
                data={hwModal}
                onClose={() => setHwModal(null)}
                formData={formData}
                lessons={lessons}
            />
        </div>
    )
}

export default ClassbookChart
